'use es6';

import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/transitional/components/View';
import PropTypes from 'prop-types';
import { Component, memo } from 'react';
import styled from 'styled-components';
import { GridSize } from '../../constants/table';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SquatchCell = styled.div.withConfig({
  displayName: "TableInsertPopoverBody__SquatchCell",
  componentId: "r85wto-0"
})(({
  theme,
  $hovered,
  $marginTop,
  $marginLeft
}) => ({
  padding: theme.space['200'],
  marginBlockStart: `${$marginTop ? theme.space['50'] : 0}`,
  marginInlineStart: `${$marginLeft ? theme.space['50'] : 0}`,
  backgroundColor: $hovered ? theme.color['fill-accent-blue-subtle'] : theme.color['fill-surface-default'],
  borderColor: $hovered ? theme.color['fill-accent-blue-default'] : theme.color['border-core-default'],
  borderRadius: theme.borderRadius['100'],
  borderStyle: 'solid',
  borderWidth: theme.borderWidth['100'],
  display: 'inline-block',
  position: 'relative',
  width: 'auto',
  userSelect: 'none',
  cursor: 'pointer'
}));
const GridCell = /*#__PURE__*/memo(props => {
  const {
    row,
    col,
    hovered
  } = props;
  const handleMouseOver = () => {
    props.onMouseOver({
      row,
      col
    });
  };
  const handleClick = () => {
    props.onClick({
      row,
      col
    });
  };
  return /*#__PURE__*/_jsx(SquatchCell, {
    $hovered: hovered,
    $marginTop: row > 1,
    $marginLeft: col > 1,
    onMouseOver: handleMouseOver,
    onClick: handleClick
  });
});
export default class TableInsertPopoverBody extends Component {
  constructor(props) {
    super(props);
    this.handleCellClick = ({
      row,
      col
    }) => {
      const {
        onInsertTable
      } = this.props;
      onInsertTable(col, row);
    };
    this.handleCellHover = ({
      row,
      col
    }) => {
      this.setState({
        hoveredCell: {
          row,
          col
        },
        gridSize: {
          rows: Math.max(GridSize.MIN, Math.min(GridSize.MAX, row + 1)),
          cols: Math.max(GridSize.MIN, Math.min(GridSize.MAX, col + 1))
        }
      });
    };
    this.state = {
      hoveredCell: {
        row: 0,
        col: 0
      },
      gridSize: {
        rows: GridSize.MIN,
        cols: GridSize.MIN
      }
    };
  }
  getTableGrid() {
    const {
      hoveredCell,
      gridSize
    } = this.state;
    const grid = [];
    for (let row = 1; row <= gridSize.rows; row++) {
      const cells = [];
      for (let col = 1; col <= gridSize.cols; col++) {
        const hovered = row <= hoveredCell.row && col <= hoveredCell.col;
        cells.push( /*#__PURE__*/_jsx(GridCell, {
          row: row,
          col: col,
          hovered: hovered,
          onMouseOver: this.handleCellHover,
          onClick: this.handleCellClick
        }, `cell-${col}-${row}`));
      }
      grid.push( /*#__PURE__*/_jsx(Flex, {
        children: cells
      }, row));
    }
    return grid;
  }
  render() {
    const grid = this.getTableGrid();
    const {
      hoveredCell
    } = this.state;
    return /*#__PURE__*/_jsxs(View, {
      paddingBlock: "0",
      paddingInline: "200",
      children: [grid, /*#__PURE__*/_jsx(Text, {
        as: "p",
        textAlign: "center",
        marginBlockStart: "200",
        marginBlockEnd: "100",
        children: `${hoveredCell.col} x ${hoveredCell.row}`
      })]
    });
  }
}
TableInsertPopoverBody.propTypes = {
  onInsertTable: PropTypes.func.isRequired
};